module.exports = __webpack_public_path__ + "logo_55-a976fe8288329596972da4af9d88bd3a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/leagues/logo_55.png
// module id = 1142
// module chunks = 0 1